import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "프레임워크",
  "description": "좋아하는 프레임워크를 Turborepo에 통합하세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 모든 프레임워크와 함께 작동합니다. 아래에서 Turborepo와 함께 사용되는 가장 일반적인 프레임워크에 대한 가이드를 찾을 수 있습니다."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 ", _jsx(_components.strong, {
        children: "모든 프레임워크"
      }), "와 함께 작동합니다. 아래에서 Turborepo와 함께 사용되는 가장 일반적인 프레임워크에 대한 가이드를 찾을 수 있습니다."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Next.js",
        href: "/docs/guides/frameworks/nextjs"
      }), _jsx(Card, {
        title: "SvelteKit",
        href: "/docs/guides/frameworks/sveltekit"
      }), _jsx(Card, {
        title: "Vite",
        href: "/docs/guides/frameworks/vite"
      }), _jsx(Card, {
        title: "Nuxt",
        href: "/docs/guides/frameworks/nuxt"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
